import * as React from 'react';
import { classes, style } from 'typestyle';
import { tinyStyle } from '../../../../styles/text';
export default class TabButton extends React.Component {
    render() {
        const { className, title, icon, selected, onClick } = this.props;
        return (React.createElement("button", { onClick: onClick, className: classes('ta-tab-button', selected && `ta-tab-button-selected`, tabButtonStyle, className) },
            React.createElement("span", { className: classes('ta-tab-button-icon', iconStyle) }, icon),
            React.createElement("span", { className: classes('ta-tab-button-title', tinyStyle) }, title)));
    }
}
const tabButtonStyle = style({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
    height: 48,
    minWidth: 60,
    padding: '6px 18px 6px 18px',
    borderRadius: '12px',
    cursor: 'pointer',
    outline: 'none',
    border: 'none',
});
const iconStyle = style({
    display: 'flex',
});
//# sourceMappingURL=TabButton.js.map